import { createFileRoute } from '@tanstack/react-router';
import { ItensListaPage, lerBuscaItens } from '@/components/item-cadastro';

export const Route = createFileRoute('/_app/cadastros/itens/')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaItens(bruto),
  component: ListaRota,
});

function ListaRota() {
  return <ItensListaPage busca={Route.useSearch()} />;
}
